import React, { useState, useEffect, useCallback } from 'react';
import collegeConfig from '../../config/collegeConfig';

// Checkbox list of UG-teaching faculty, backed by GET /api/ug/faculty.
// Shared by any student form that needs to address a request to specific
// real faculty accounts (DOAP, Professionalism/FAP) instead of a free-text
// name — value/onChange carry an array of teacher ids.
const TeacherMultiSelect = ({ value, onChange }) => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${collegeConfig.api.baseURL}/ug/faculty`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) setTeachers(data.teachers || []);
      } catch (err) {
        console.error('Error fetching UG faculty list:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchTeachers();
  }, [token]);

  const toggle = useCallback((teacherId) => {
    if (value.includes(teacherId)) {
      onChange(value.filter(id => id !== teacherId));
    } else {
      onChange([...value, teacherId]);
    }
  }, [value, onChange]);

  if (loading) {
    return <div className="ug-due-empty" style={{ padding: '10px 0' }}>Loading faculty list...</div>;
  }
  if (teachers.length === 0) {
    return <div className="ug-due-empty" style={{ padding: '10px 0' }}>No UG faculty available yet — check with admin.</div>;
  }

  return (
    <div className="ug-teacher-multiselect">
      {teachers.map(t => (
        <label key={t._id} className="ug-teacher-multiselect-option">
          <input
            type="checkbox"
            checked={value.includes(t._id)}
            onChange={() => toggle(t._id)}
          />
          {t.profile?.firstName} {t.profile?.lastName}
        </label>
      ))}
    </div>
  );
};

export default TeacherMultiSelect;
